import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { JwtService, ApiService, UserService } from '@app/core';
import { ActivatedRoute } from '../../../node_modules/@angular/router';
import { Router } from '../../../node_modules/@angular/router';


@Component({
  selector: 'app-bulkemail',
  templateUrl: './bulkemail.component.html',
  styleUrls: ['./bulkemail.component.scss']
})
export class BulkemailComponent implements OnInit {

  bulkEmailForm: FormGroup;
  message: string;
  // userId: string = this.jwtService.getCurrentUserID();
  //userId: string = JSON.parse(localStorage.getItem('credentials')).id;
  msgColor: string;
  asterik: string;
  action: string;
  notifId: number;
  notificationId: string;
  pageheading: string;
  isError: boolean = false;
  isPublishError:boolean = false;
   isSaveSuccess: boolean = false;
  isPublishSuccess: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private jwtService: JwtService,
    private apiService: ApiService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.createForm();
  }

  ngOnInit() {

    //alert("Test");
    this.route.queryParams.subscribe(params => {
      //console.log(params);

      // if(params['id']){
      //   console.log(params['id']);
      // } else {
      //   console.log('id not found in params')
      // }

      this.notifId = params['id'];
      this.action = params['action'];
    });
    if (this.notifId != null && this.action != null) {
      this.checkLink(this.action);
      this.getBulkNotification();
    }

    //this.getUser(); 
  }

  checkLink(invokedFrom: string) {
    if (invokedFrom === 'view') {
      this.pageheading = "View Notification";
    } else if (invokedFrom === 'edit') {
      this.pageheading = "Edit Notification";
    } else {
    }
  }


  cancel() {
    this.router.navigate(['/home'], { queryParams: { tab: "Notifications" } });
    // location.reload();
    setTimeout(() => window.location.reload());
    this.bulkEmailForm.patchValue({
      subject: null,
      body: null,
      url: null
    });
  }

  publish() {
    //alert("publish");
    var proData = this.bulkEmailForm.value;
    // if (this.bulkEmailForm.invalid) {
    //   console.log("Inside Form Invalid Block");
    //   this.isError = true;
    //   return;
    // }
    this.userService.publishBulkEmail(proData.id).subscribe(
      res => {
        if (res.code == '200') {
          this.bulkEmailForm.reset();

          // this.bulkEmailForm.markAsPristine();
          //   this.bulkEmailForm.markAsUntouched();
          //   this.bulkEmailForm.updateValueAndValidity();

          // this.bulkEmailForm.patchValue({
          //   id : null,
          //   body: null,
          //   subject: null,
          //   url:null
          //    });

          this.message = res.message;
          this.msgColor = 'green';
          this.asterik = '*';
          this.isSaveSuccess = false;
          setTimeout(function () {
            this.message = null;
            this.asterik = null;
          }.bind(this), 5000);
        }
      },
      err => {
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
      }
    );
  }

  save() {
    var bulkdata = this.bulkEmailForm.value;
    // if (this.bulkEmailForm.invalid) {
    //   console.log("Inside Form Invalid Block");
    //   this.isError = true;
    //   return;
    // }
    // const data = { "body": bulkdata.body, "subject": bulkdata.subject, "url": bulkdata.url, "userId": this.userId, "bulkNotificationId": bulkdata.id };
    const data = { 
      "body": bulkdata.body, 
      "subject": bulkdata.subject, 
      "url": bulkdata.url, 
      "userId": JSON.parse(localStorage.getItem('credentials')).id, 
      "bulkNotificationId": bulkdata.id 
    };



    this.userService.bulkEmail(data).subscribe(
      res => {
        if (res.code == '200') {
          this.bulkEmailForm.patchValue({
            id: res.data.notification.id
          });
          this.message = res.message;
          this.msgColor = 'green';
          this.asterik = '*';
          this.isSaveSuccess = true;
          setTimeout(function () {
            this.message = null;
            this.asterik = null;
          }.bind(this), 5000);
        }
      },
      err => {
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
      }
    );
  }
  getBulkNotification() {
    //alert("Hey");
    let url = "/bulk/notifications/" + this.notifId;

    this.apiService.get(url).subscribe(
      response => {
        this.bulkEmailForm.patchValue({
          id: response.data.notification.id,
          subject: response.data.notification.emailSubject,
          body: response.data.notification.emailBody,
          url: response.data.notification.customUrl
        });
      }
    )
  }

  getStatusColor() {
    return this.msgColor;
  }

  // private createForm() {
  //   this.bulkEmailForm = this.formBuilder.group({
  //     subject: ['', Validators.required],
  //     body: ['', Validators.required],
  //     url: [''],
  //     id : ['']
  //   });
  // }  

  private createForm() {
    this.bulkEmailForm = this.formBuilder.group({
      // subject:['',[Validators.required,Validators.maxLength(256)]],
      // body:['', [Validators.required,Validators.maxLength(4000)]],
      subject:[null, Validators.required],
      body:[null, Validators.required],
      url: [null],
      id: [null]
    });
  }
}

